import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { allRoutes } from '../../app/routeConfig';
import { useAuth } from '../auth/AuthContext';
import { getFirstAccessiblePath, resolvePostLoginPath } from '../utils/routeAccess';
import { userHasPermission } from '../utils/permissions';

export function ProtectedRoute({ children, permission }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission && !userHasPermission(user, permission)) {
    const fallback = getFirstAccessiblePath(user, allRoutes);
    if (fallback && fallback !== location.pathname) {
      return <Navigate to={fallback} replace />;
    }
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export function PublicOnlyRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (isAuthenticated) {
    const path = resolvePostLoginPath(user, location.state?.from?.pathname, allRoutes);
    return <Navigate to={path} replace />;
  }

  return children;
}
